import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Program } from 'models/programs.types';

import { RootState } from 'store';
import { ProgramsCatalogState } from './programsCatalog.types';

const initialState: ProgramsCatalogState = {
  catalog: []
};

const programsCatalogSlice = createSlice({
  initialState,
  name: 'programsCatalog',
  reducers: {
    setProgramsCatalog: (state, action: PayloadAction<Program[]>) => {
      // Upsert by `_id` instead of replacing — `getPrograms` accepts params, so a filtered call
      // (e.g. only WM programs) must not wipe the rest of the cached catalog. Mirrors
      // `setPrograms` in `programsSlice`.
      action.payload.forEach((program) => {
        const index = state.catalog.findIndex((cached) => cached._id === program._id);
        if (index !== -1) {
          state.catalog[index] = program;
        } else {
          state.catalog.push(program);
        }
      });
    }
  }
});

export const { setProgramsCatalog } = programsCatalogSlice.actions;

export const selectProgramsCatalog = (state: RootState) => state.programsCatalog.catalog;

export default programsCatalogSlice.reducer;
